import React from 'react'
import Eta from '../../components/general/Eta'
import Banner from '../../components/general/Banner'
import newsimg from '../../assets/images/news-detail.svg'
import { useTranslation } from 'react-i18next'

const NewsDetail = () => {
    const { t } = useTranslation()

    return (
    <Eta>
            <Banner title={t("news_title")} description={(t("news_desc"))} />
            <div className='news-detail-page'>
                <div><img src={newsimg} alt='' className='w-100' /></div>
                <div className='mt-4'>
                    <div><small className='color2'>{t("date_time")}</small></div>
                    <div className='mt-2'><strong className='f24 fw500 color7'>{t("news1_title")}</strong></div>
                    {/* <div className='mt-2'><span className='f16 fw400 color6'>{t("lorem2")}</span></div>
                    <div><span className='f16 fw400 color6'>{t("lorem2")}</span></div> */}
                </div>
            </div>
        </Eta>
    )
}

export default NewsDetail
